import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable , AsyncSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { SpinnerService } from '../services/spinner/spinner.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {


  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private toastr: ToastrService,
    private spinnerService: SpinnerService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const subject = new AsyncSubject<HttpEvent<any>>();

    next.handle(request)
      .pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            subject.next(event);
            subject.complete();
          }
        }, (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401 || err.status === 403) {
              this.spinnerService.hide();
              this.authenticationService.logout();
              this.router.navigate(['/login']);
            } else if (err.status === 404) {
              this.spinnerService.hide();
              this.router.navigate(['/authentication/404']);
            } else {
              this.showErrorMessage(err);
            }
          }


          const errorEvent = new HttpResponse({});
          subject.next(errorEvent);
          subject.complete();


        })).subscribe();

    return subject;
  }


  showErrorMessage(error) {

    this.spinnerService.hide();

    if (error.error.subErrors != null) {
      error.error.subErrors.forEach(singleError => {
        this.toastr.error(singleError.message, singleError.message, {
          timeOut: 10000
        });
      })
    } else {
      let message = error.error.message;
      let status = "";
      if (typeof error.error.status != typeof undefined) {
        status = error.error.status;
      } else if (typeof error.status != typeof undefined) {
        status = error.status;
      }
      this.toastr.error(message, status, {
        timeOut: 10000
      });
    }
  }
}